module.exports = __webpack_public_path__ + "static/media/pathways-logo-pad.bf2d3770.png";